var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 3.429C11.2 2.64 10.572 2 9.8 2H1.4C.628 2 0 2.64 0 3.429v7.142C0 11.36.628 12 1.4 12h8.4c.772 0 1.4-.64 1.4-1.429v-2.38l2.8 2.38V3.43l-2.8 2.38V3.43z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.737L11.737 2",
    stroke: "#E39685",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
export default SvgCamOff;